import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { userId } from '@/common/const';
import BUCKET from '@/utils/bucket';
import { bucket } from '@/utils/env';
import { getRecords, FLOW_TYPE } from '@/services/history';
import axios from './axios';
// diamonds
export var getDiamondsBalance = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post('/rest/o/wallet/diamond/info');
          case 2:
            res = _context.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", Number((res === null || res === void 0 ? void 0 : res.balance) || 0));
          case 5:
            return _context.abrupt("return", 0);
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getDiamondsBalance() {
    return _ref.apply(this, arguments);
  };
}();
export var getDiamondsHistoryList = function getDiamondsHistoryList(params) {
  return axios.post('/rest/o/wallet/diamond/purchase_history', params);
};
// koin
export var getKoinBalance = function getKoinBalance() {
  return axios.post('/rest/o/wallet/koin/info');
};
export var getKoinRecords = function getKoinRecords(params) {
  return axios.post('/rest/o/wallet/koin/withdraw/list', params);
};
export var getLiveRevenueBalance = function getLiveRevenueBalance(params) {
  return axios.post('/rest/o/wallet/live/info', params);
};
export var getLiveGameBalance = function getLiveGameBalance(params) {
  return axios.post('/rest/o/wallet/live/bg/game/info', params);
};
export var getLiveKoinRecords = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
    var res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.post('/rest/o/wallet/live/koin/records', params);
          case 2:
            res = _context2.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", _objectSpread({
              result: 1
            }, res.data));
          case 5:
            return _context2.abrupt("return", null);
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function getLiveKoinRecords(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var getLiveCashRecord = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
    var res;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.post('/rest/o/wallet/live/cash/records', params);
          case 2:
            res = _context3.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", _objectSpread({
              result: 1
            }, res.data));
          case 5:
            return _context3.abrupt("return", null);
          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function getLiveCashRecord(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var getLiveGiftRecords = function getLiveGiftRecords(pcursor) {
  return axios.get("/rest/bulldog/pay/wallet/giftReceiveList?pcursor=".concat(pcursor));
};
// creator
export var getCreatorRewardsBalance = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.post('/rest/o/wallet/creator/balance');
          case 2:
            res = _context4.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return", res.data.balance || '0');
          case 5:
            return _context4.abrupt("return", '0');
          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function getCreatorRewardsBalance() {
    return _ref4.apply(this, arguments);
  };
}();
export var getCreatorRewardsRecords = function getCreatorRewardsRecords(params) {
  return axios.post('/rest/o/wallet/creator/transactions', params);
};
export var getCreatorRewardsRecordsV2 = function getCreatorRewardsRecordsV2(params) {
  return getRecords({
    pcursor: params.pcursor,
    flowType: FLOW_TYPE.creatorCash
  });
};
// snack-拍客工资
export var getCreatorPartnerBalance = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var res;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.post('/rest/o/wallet/partner/balance');
          case 2:
            res = _context5.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context5.next = 5;
              break;
            }
            return _context5.abrupt("return", res.data.balance || '0');
          case 5:
            return _context5.abrupt("return", '0');
          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function getCreatorPartnerBalance() {
    return _ref5.apply(this, arguments);
  };
}();
export var getCreatorPartnerRecords = function getCreatorPartnerRecords(params) {
  return axios.post('rest/o/wallet/partner/transactions', params);
};
export var getCreatorPartnerRecordsV2 = function getCreatorPartnerRecordsV2(params) {
  return getRecords({
    pcursor: params.pcursor,
    flowType: FLOW_TYPE.creatorPartner
  });
};
// cash
export var getCashBalance = function getCashBalance(balanceType) {
  return axios.post('/rest/o/wallet/cash/balance', {
    balance_type: balanceType
  });
};
export var getCashWithdrawItems = function getCashWithdrawItems(balanceType) {
  return axios.post('/rest/o/wallet/cash/withdraw/items', {
    balance_type: balanceType
  });
};
export var getCashRecords = function getCashRecords(params) {
  return axios.post('/rest/o/wallet/cash/list', params);
};
// event
export var getEventBalance = function getEventBalance(balanceType) {
  return axios.post('/rest/o/wallet/cash/event/balance', {
    balance_type: balanceType
  });
};
export var getEventWithdrawItems = function getEventWithdrawItems(balanceType) {
  return axios.post('/rest/o/wallet/cash/withdraw/items', {
    balance_type: balanceType
  });
};
export var getEventsRecords = function getEventsRecords(params) {
  return axios.post('/rest/o/wallet/cash/list', params);
};
// 查询用户桶和国家信息
export var getUserCookieInfo = function getUserCookieInfo() {
  return axios.post('/rest/o/wallet/user/info');
};
/**
 * 接口获取Kconf配置
 * @param key kconf对应字段名
 */
export var getKConfData = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(kconfKey) {
    var res;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(!kconfKey || !kconfKey.length)) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            _context6.prev = 2;
            _context6.next = 5;
            return axios.post('/rest/o/w/kconf/loggedOut', {
              paths: kconfKey
            }, {
              headers: {
                'content-type': 'application/json'
              },
              showLoading: false,
              silent: true
            });
          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](2);
            console.warn('get Kconf error', _context6.t0);
            return _context6.abrupt("return", Promise.reject(_context6.t0));
          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 9]]);
  }));
  return function getKConfData(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * 接口获取Kconf配置
 * @param kconfKey kconf对应字段名
 */
export function getKConfData2(_x4) {
  return _getKConfData.apply(this, arguments);
}
function _getKConfData() {
  _getKConfData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(kconfKey) {
    var _res$data, res, jsonStr;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return axios.post('/rest/o/w/kconf/loggedOut', {
              paths: [kconfKey]
            }, {
              headers: {
                'content-type': 'application/json'
              },
              showLoading: false,
              silent: true
            });
          case 3:
            res = _context12.sent;
            jsonStr = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data[kconfKey];
            if (!jsonStr) {
              _context12.next = 7;
              break;
            }
            return _context12.abrupt("return", JSON.parse(jsonStr));
          case 7:
            return _context12.abrupt("return", Promise.reject("\u83B7\u53D6Kconf\u5185\u5BB9\u4E3A\u7A7A\uFF0CkconfKey: ".concat(kconfKey)));
          case 10:
            _context12.prev = 10;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", Promise.reject(_context12.t0));
          case 13:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 10]]);
  }));
  return _getKConfData.apply(this, arguments);
}
;
// Spotlight
export var getSpotlightBalance = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    var res;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return axios.post('/rest/o/wallet/spotlight/balance');
          case 2:
            res = _context7.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context7.next = 5;
              break;
            }
            return _context7.abrupt("return", res.data.balance || '0');
          case 5:
            return _context7.abrupt("return", '0');
          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function getSpotlightBalance() {
    return _ref7.apply(this, arguments);
  };
}();
export var getSpotlightRecords = function getSpotlightRecords(params) {
  return axios.post('rest/o/wallet/spotlight/transactions', params);
};
export var getSpotlightRecordsV2 = function getSpotlightRecordsV2(params) {
  return getRecords({
    pcursor: params.pcursor,
    flowType: FLOW_TYPE.creatorSpotlight
  });
};
// Spotlight本地化钱包
export var getSpotlightLocalBalance = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var res;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return axios.post('/rest/o/wallet/spotlight/local/balance');
          case 2:
            res = _context8.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return", res.data.balance || '0');
          case 5:
            return _context8.abrupt("return", '0');
          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return function getSpotlightLocalBalance() {
    return _ref8.apply(this, arguments);
  };
}();
export var getSpotlightLocalRecords = function getSpotlightLocalRecords(params) {
  return axios.post('rest/o/wallet/spotlight/local/transactions', params);
};
export var getSpotlightLocalRecordsV2 = function getSpotlightLocalRecordsV2(params) {
  return getRecords({
    pcursor: params.pcursor,
    flowType: FLOW_TYPE.creatorSpotlightLocal
  });
};
export var getAppreciationRecords = function getAppreciationRecords(params) {
  return axios.post('/rest/o/wallet/appreciate/transactions', params);
};
// creator br美金钱包
export var getCreatorDollarBalance = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    var res;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return axios.post('/rest/o/wallet/creator/paike/balance');
          case 2:
            res = _context9.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) === 1)) {
              _context9.next = 5;
              break;
            }
            return _context9.abrupt("return", res.data.balance || '0');
          case 5:
            return _context9.abrupt("return", '0');
          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return function getCreatorDollarBalance() {
    return _ref9.apply(this, arguments);
  };
}();
export var getCreatorDollarRecords = function getCreatorDollarRecords(params) {
  return axios.post('/rest/o/wallet/creator/paike/transactions', params);
};
export var getCreatorDollarRecordsV2 = function getCreatorDollarRecordsV2(params) {
  return getRecords({
    pcursor: params.pcursor,
    flowType: FLOW_TYPE.creatorPartner
  });
};
// 收礼记录
export var getLiveGiftReceiveRecord = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(params) {
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", axios.post('/rest/o/w/live/v2/gift/history/receive', params));
          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return function getLiveGiftReceiveRecord(_x5) {
    return _ref10.apply(this, arguments);
  };
}();
// 收礼记录
export var getLiveGiftSendRecord = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(params) {
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", axios.post('/rest/o/w/live/v2/gift/history/send', params));
          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return function getLiveGiftSendRecord(_x6) {
    return _ref11.apply(this, arguments);
  };
}();
// 金币流水记录 https://docs.corp.kuaishou.com/d/home/fcADAWSl0LCH4Sk-OsuJ7UMAz
export function getCoinRecords(params) {
  return axios.post('/rest/o/wallet/coin/list', {
    pcursor: params.pcursor || '0',
    // "activityId":"100024",  印尼传100024，巴基斯坦传100033
    activityId: BUCKET.Indonesia === bucket ? 100024 : 100033
  });
}
;
export function getBocaiDiamondRecord(params) {
  return axios.post('/rest/o/wallet/diamond/flow/bocai', params);
}
export var diamondExchangeFields = ['enableKoinExchangeDiamond', 'enableLiveCashExchangeDiamond', 'enableIncentiveCashExchangeDiamond', 'enableIncentivePointExchangeDiamond'];
export function getAbEnable() {
  return axios.post('/rest/o/wallet/live/switches');
}
export var getKoinExchangeRule = function getKoinExchangeRule(params) {
  params.userId = userId;
  return axios.post('/rest/o/wallet/live/koin/exchange/diamond/rule', params, {
    showLoading: false
  });
};
export var applyKoinExchange = function applyKoinExchange(params) {
  params.userId = userId;
  return axios.post('/rest/o/wallet/live/koin/exchange/diamond/apply', params, {
    silent: true
  });
};
export var getCashExchangeRule = function getCashExchangeRule(params) {
  params.userId = userId;
  return axios.post('/rest/o/wallet/live/cash/exchange/diamond/rule', params, {
    showLoading: false
  });
};
export var applyCashExchange = function applyCashExchange(params) {
  params.userId = userId;
  return axios.post('/rest/o/wallet/live/cash/exchange/diamond/apply', params, {
    silent: true
  });
};
export var getCashNotice = function getCashNotice() {
  return axios.get('/rest/o/wallet/live/cash/exchange/diamond/notice', {
    showLoading: false
  });
};
export var getKoinNotice = function getKoinNotice() {
  return axios.get('/rest/o/wallet/live/koin/exchange/diamond/notice', {
    showLoading: false
  });
};
export var getIncentiveExchangeRule = function getIncentiveExchangeRule(params) {
  params.userId = userId;
  return axios.post('/rest/o/wallet/live/incentive/income/exchange/diamond/rule', params, {
    showLoading: false
  });
};
export var applyIncentiveExchange = function applyIncentiveExchange(params) {
  params.userId = userId;
  return axios.post('/rest/o/wallet/live/incentive/income/exchange/diamond/apply', params, {
    silent: true
  });
};